import { SiteSettingsScope } from '../../enums';
import { siteContext, siteSettingsHttp } from '../site-settings-api';

export const getSiteSettings = async <T>(
  locale: string,
  scope: SiteSettingsScope | SiteSettingsScope[]
): Promise<T> => {
  const scopes = Array.isArray(scope) ? scope.join(',') : scope;
  const url = `/settings?site=${siteContext}&marketLocale=${locale}&scope=${scopes}`;
  const response = await siteSettingsHttp.get<T>(url);
  return response.data;
};
